<!-- საკონტაქტო  -->
<div class="filled" [ngClass]="!editModeMap[2] ? 'success' : 'danger'">
  <div class="row align-items-center filled-row justify-content-xs-center" *ngIf="!editModeMap[2]">
    <div class="col filled-title">
      საკონტაქტო ინფორმაცია
    </div>
    <div class="col">
      <div class="d-flex flex-column">
        <p>{{this.policy.ContactInfo.email}}</p>
        <p>{{this.policy.ContactInfo.phone}}</p>
      </div>
    </div>
    <div class="col edit-btn">
      <button class="ml-m@s g-b--w0 g g--alignCenter g--nowrap cur-p edit ms-auto d-flex" (click)="onEdit(2)">
        <div class="mr-xs fz-12" style="color: #737373;">ცვლილება</div>
        <i class="fas fa-pen"></i>
      </button>
    </div>
  </div>
  <form [formGroup]="form">
    <div class="row edit-row position-relative d-flex" *ngIf="editModeMap[2]">
      <div class="contact-form col-xs-12" *ngIf="form.get('email'); let email;">
        <label for="phone">ელ.ფოსტა</label>
        <input type="text" class="form-control" formControlName="email" id="phone" aria-describedby="emailHelp"
          placeholder="შეიყვანე ელ.ფოსტა" [ngClass]="{'has-error': !email.valid && submitted}">

      </div>

      <div class="contact-form col-xs-12" *ngIf="form.get('phone'); let phone;">
        <label for="phone">ტელ.ნომერი</label>
        <input type="text" (keypress)="numberOnly($event)" class="form-control" formControlName="phone" id="phone"
          aria-describedby="emailHelp" placeholder="შეიყვანე ტელ.ნომერი"
          [ngClass]="{'has-error': !phone.valid && submitted}">

      </div>

      <div class="done" (click)="done(2)">
        შენახვა
      </div>
    </div>
  </form>
</div>
<!-- საკონტაქტო  -->
